module.exports = __webpack_public_path__ + "static/assets/d1622a24118bd5fef72d13f2b0a2d191.png";